const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');
const customParseFormat = require('dayjs/plugin/customParseFormat');
const isoWeek = require('dayjs/plugin/isoWeek');
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
require('dayjs/locale/pt-br');

/*
 * Day.js with the plugins used by the project, shared by the front end (@common/dayjs) and the functions (common_dist/dayjs)
 * Day.js objects are immutable: add, subtract, startOf, endOf, locale and the setters return a new object
 */

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
dayjs.extend(isSameOrBefore);

module.exports = dayjs;
